import React, { useState, useEffect } from 'react';
import { axiosInstance } from '@/axiosConfig';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { Loader2, ShieldAlert } from 'lucide-react';
import { toast } from 'sonner';

export default function Auditoria() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async () => {
    try {
      const res = await axiosInstance.get('/auditoria');
      setLogs(res.data);
    } catch (error) {
      console.error(error);
      toast.error("Erro ao carregar logs de auditoria.");
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="flex justify-center p-8"><Loader2 className="animate-spin text-blue-600" /></div>;

  return (
    <div className="container mx-auto px-6 py-8">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900 flex items-center gap-2">
            <ShieldAlert className="w-8 h-8 text-blue-600"/> Logs de Auditoria
        </h1>
        <p className="text-gray-600">Rastreabilidade de ações sensíveis no sistema.</p>
      </div>

      <Card>
        <CardHeader>
            <CardTitle>Histórico de Ações</CardTitle>
        </CardHeader>
        <CardContent>
            <div className="rounded-md border">
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHead>Data/Hora</TableHead>
                            <TableHead>Usuário</TableHead>
                            <TableHead>Ação</TableHead>
                            <TableHead>Detalhes</TableHead>
                            <TableHead>IP</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {logs.length === 0 ? (
                            <TableRow><TableCell colSpan={5} className="text-center py-4">Nenhum registro encontrado.</TableCell></TableRow>
                        ) : (
                            logs.map((log) => (
                                <TableRow key={log._id}>
                                    <TableCell className="text-xs text-gray-500">
                                        {new Date(log.data_hora).toLocaleString()}
                                    </TableCell>
                                    <TableCell className="font-medium">
                                        {log.usuario_nome}
                                    </TableCell>
                                    <TableCell>
                                        <Badge variant="outline" className="bg-gray-50">
                                            {log.acao}
                                        </Badge>
                                    </TableCell>
                                    <TableCell className="text-xs text-gray-600 max-w-md truncate" title={JSON.stringify(log.detalhes)}>
                                        {JSON.stringify(log.detalhes || {})}
                                    </TableCell>
                                    <TableCell className="text-xs text-gray-400">
                                        {log.ip_address || '-'}
                                    </TableCell>
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </div>
        </CardContent>
      </Card>
    </div>
  );
}